// extracted by mini-css-extract-plugin
export default {"cls1":"nuKa2vDYPYiFrKS2qAD9","cls2":"mJiDhHM10PJXEeNiPY89 nuKa2vDYPYiFrKS2qAD9"};